import { render, staticRenderFns } from "./ui-design.vue?vue&type=template&id=1962fce8&lang=pug"
import script from "./ui-design.vue?vue&type=script&lang=js"
export * from "./ui-design.vue?vue&type=script&lang=js"
import style0 from "./ui-design.vue?vue&type=style&index=0&id=1962fce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports